import React, { useState, useEffect, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectiDB,
  selectVersion,
  updateState,
  UpdateVersionByImport,
  selectVersionByImport,
} from "../counter/counterSlice";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
new Worker(new URL("../../workers/download.js", import.meta.url), { type: "module" });

const NavBar = React.lazy(() => import("../../components/navBar"));
const TopicBanner = React.lazy(() => import("../../components/topicBanner"));
const Footer = React.lazy(() => import("../../components/footer"));

const Import = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const search = location.search;
  const iDB = useSelector(selectiDB);
  const ccmsversion = useSelector(selectVersion);
  const [version, setVersion] = useState("");
  const versionByImport = useSelector(selectVersionByImport);
  const dispatch = useDispatch();
  const { authID } = useAuth();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAuthChecked(true);
    }, 1000);

    if (authID.u || authID.i) {
      setAuthChecked(true);
      clearTimeout(timer);
    }

    return () => clearTimeout(timer);
  }, [authID.u, authID.i]);

  useEffect(() => {
    if (!authChecked) return;

    const isAuthenticated = authID.u || authID.i;

    if (!isAuthenticated) {
      navigate("/");
      return;
    }
    iDB.keys().then((keys) => {
      console.log("keys:", keys);
      console.log("ccmsversion", ccmsversion.selected);
    });
  }, [authID.u, authID.i, authChecked]);

  const handleVersionChange = (e) => {
    const newValue = e.target.value;
    iDB.clear().then(() => {
      iDB.keys().then((keys) => {
        setVersion(newValue);
        dispatch(updateState({ version: { ...ccmsversion, selected: newValue } }));
        iDB.config({ name: newValue });
        dispatch(UpdateVersionByImport(true));
      });
    });
  };

  useEffect(() => {
    iDB.keys().then((keys) => {
      console.log(ccmsversion);
    });
  }, []);

  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        <NavBar push={navigate} />
        <TopicBanner pathname={pathname} search={search} push={navigate} />
        <div className="import-card-container" style={{ height: "50vh" }}>
          <div className="import-card">
            <h3 className="text-center" style={{ textAlign: "center" }}>
              Select Content Slot
            </h3>
            <div className="form-group" style={{ "marginBottom:": "15px" }}>
              <label htmlFor="options">Change slot:</label>
              <select
                className="import-form-control"
                id="options"
                value={version}
                onChange={(e) => handleVersionChange(e)}
              >
                <option value="" disabled>
                  Select a version
                </option>
                {ccmsversion.items.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              {versionByImport && (
                <p style={{ color: "green" }}>
                  Content has been successfully updated to {version}{" "}
                </p>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </Suspense>
    </>
  );
};

export default Import;
